// src/mixins/windowSizeMixin.js
//混入，实时获取宽高并把判断是否是手机端，需要在调用的地方+watch
export default {
    data() {
        return {

            windowWidth: window.windowWidth, //视窗高度

        };
    },
    mounted() {
        this.handleResize(); // 初始化时获取一次宽度
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        handleResize() {
            //媒体查询写法
            const isMobile = window.matchMedia('(max-width: 768px)').matches;
            this.MobileVerification = isMobile;
            //bom写法
            // this.MobileVerification =
            // 	window.innerWidth <= 769 ||
            // 	/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            // 		navigator.userAgent
            // 	);
            this.windowWidth = window.innerWidth;
        },
    },
};